import React, { useRef } from 'react';
import { Layout } from 'antd';
import { Helmet } from 'react-helmet';

import '../../components/admin/assets/css/common.css';
import EventSuperAdminNavBar from '../../components/AnglingTrust/rdo_compliance_management/components/EventSuperAdminNavBar';

const { Content } = Layout;

function EventSuperAdminLayout(props) {
  const containerRef = useRef(null);

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>Events Management Portal | swimbooker</title>
      </Helmet>
      <Content id='admin-container' className='fishery-admin-container'>
        <div id='admin-menu'>
          <EventSuperAdminNavBar containerRef={containerRef} />
        </div>
        <div id='admin-content' className='fishery-admin-content'>
          <div id='admin-drawer-container' ref={containerRef} />
          {props.children}
        </div>
      </Content>
    </>
  );
}

export default EventSuperAdminLayout;
